import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import formItem from "./components/formItem.vue";
import formParam from "./components/formParam.vue";
import { inputComponents, selectComponents, auxiliaryComponents } from "./config/config";
import vuedraggable from "vuedraggable";
export default {
  components: {
    formItem: formItem,
    formParam: formParam,
    vuedraggable: vuedraggable
  },
  props: {
    info: {
      type: Array
    }
  },
  updated: function updated() {
    this.$emit("change", this.config);
  },
  data: function data() {
    return {
      config: [],
      index: 0,
      // lastIndex: 1000,
      true: true,
      drawer: false,
      updateParam: {},
      elementBase: [
      // {
      //     title: "功能型组件",
      //     list: functionalComponents,
      // },
      {
        title: "输入型组件",
        list: inputComponents
      }, {
        title: "选择型组件",
        list: selectComponents
      }, {
        title: "辅助型组件",
        list: auxiliaryComponents
      }],
      keyValue: 0
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.config = JSON.parse(JSON.stringify(this.info));
      for (var i = 0; i < this.config.length; i++) {
        this.config[i].item_id = i + 1;
      }
    },
    addBox: function addBox(component) {
      var box = JSON.parse(JSON.stringify(component));
      box.item_id = this.config.length + 1;
      this.config.push(box);
      this.select(this.config.length - 1);
      this.updateParam = this.config[this.config.length - 1];
    },
    removeBox: function removeBox(index) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.config.splice(index, 1);
              _this.keyValue++;
              _this.index = 0;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    select: function select(index) {
      this.index = this.config[index]["item_id"];
      this.updateParam = this.config[index];
    },
    changeDrag: function changeDrag() {
      this.keyValue++;
    }
  }
};